/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
import customUtil from '../../../objects/customUtil.js';

import BootstrapDialog from 'bootstrap3-dialog/dist/js/bootstrap-dialog';

class customOptionsModel {

    constructor(params) {
        // Profile
        this.componentName = ko.observable("customOptions");
        this.context = context;
        //this.id = this.context.util.guid();
        this.id = '30411c19-1af2-4cd0-90ea-e1cc6d94e101';
        this.visible = ko.observable(true);
        this.columnid = params.columnid;
        this.customUtilObj = new customUtil(this.context);

        this.editTitleActive = ko.observable(false);
        this.deleteEnable = ko.observable(false);

        this.addUpdateTitle = ko.observable("Add");

        this.customHeaderTitlesArray = ko.observableArray([]);

        this.title = ko.observable();
        this.selectedObject = ko.observable(this.customUtilObj.returnEmptyObj());
        this.contentVisible = ko.observable(false);
        this.listArray = ko.observableArray([]);

        this.context.customHeaderTitles.subscribe( data => {
            this.updateHeader();
            this.getData();
        });

        this.init();
        
    }

    init() {


    }

    reset() {

        this.selectedObject(this.customUtilObj.returnEmptyObj());
        this.addUpdateTitle("Add");
        this.deleteEnable(false);

    }

    updateHeader() {

        switch(this.columnid)
        {
            case 1:
                this.title(this.context.customHeaderTitles().optioncolumn1title);
                break;

            case 2:
                this.title(this.context.customHeaderTitles().optioncolumn2title);
                break;

            case 3:
                this.title(this.context.customHeaderTitles().optioncolumn3title);
                break;

            case 4:
                this.title(this.context.customHeaderTitles().optioncolumn4title);
                break;

            case 5:
                this.title(this.context.customHeaderTitles().optioncolumn5title);
                break;

            case 6:
                this.title(this.context.customHeaderTitles().optioncolumn6title);
                break;
            
        }

    }
        
    toggleContent() {

        this.contentVisible(!this.contentVisible());

        if(this.contentVisible())
        {
            this.getData();
            console.log("title: %s", this.title());
            console.log(this.listArray);
        }
    }

    getData() {
        
        this.listArray(null);
        this.listArray(this.customUtilObj.returnDataByCoulmnid(this.columnid)());
        this.listArray.valueHasMutated();
    }

    editItem(item,parent) {
        console.log("customOptions:editItem  - item: %o  event: %o ", item,parent);
        parent.selectedObject(item);
        parent.addUpdateTitle("Update");
        parent.deleteEnable(true);
    }

    clickEditTitle() {
        console.log("customOptions:clickEditTitle");
        this.editTitleActive(true);
    }

    updateTitle() {

        switch(this.columnid)
        {
            case 1:
                this.context.customHeaderTitles().optioncolumn1title = this.title();
                break;

            case 2:
                this.context.customHeaderTitles().optioncolumn2title = this.title();
                break;

            case 3:
                this.context.customHeaderTitles().optioncolumn3title = this.title();
                break;

            case 4:
                this.context.customHeaderTitles().optioncolumn4title = this.title();
                break;

            case 5:
                this.context.customHeaderTitles().optioncolumn5title = this.title();
                break;

            case 6:
                this.context.customHeaderTitles().optioncolumn6title = this.title();
                break;
            
        }

        this.editTitleActive(false);
        this.context.customHeaderTitles.valueHasMutated();

        this.customUtilObj.updateCustomHeaderTitles();

    }

    clickAddUpdate() {

        this.selectedObject().columnid = this.columnid;
        this.customUtilObj.updateCustomHeaderData(this.selectedObject).then( response => {
            this.customUtilObj.getCustomHeaderData(this.columnid).then( response => {
                this.reset();
                this.getData();
            });
        });

    }


    clickClear() {

        this.reset();

    }

    clickDeleteConfirm() {

        let self = this;

        BootstrapDialog.confirm('Are you sure you want to delete this item?', function(result){
            if(result) {
                console.log('customOptions:clickDeleteConfirm result %o', result);
                self.clickDelete();
            } 
        });

    }
    

    clickDelete() {

        this.selectedObject().valid = 0;

        this.customUtilObj.updateCustomHeaderData(this.selectedObject).then( response => {
            this.customUtilObj.getCustomHeaderData(this.columnid).then( response => {
                this.reset();
                this.getData();
            });
        });
        
    }

}

export default { viewModel: customOptionsModel, template: require('!raw-loader!./customOptions.html') };


// WEBPACK FOOTER //
// ./src/components/options/customOptions/customOptions.js